<div class="c1">
  <div class="c2">
    <div style="background-color:color: #333; text-align: center; padding: 20px; border-radius: 5px; margin: 20px;">
      <h2>Time to Upgrade!</h2>
      <p>We've made some exciting new improvements to our app!</p>
      <p>Please note that this version is no longer unsupported.</p>
      <a (click)="openDownloadPage()" style="display: inline-block; background-color: #008CBA; color: white; padding: 15px 25px; font-size: 18px; text-decoration: none; border-radius: 5px; margin: 10px auto;">Download Latest Version</a>
      <p>If you need help, contact our support team at <a href="mailto:support@godatahub.com">support@godatahub.com</a></p>
    </div>
  </div>
</div>
